import BaseService from '@/ecm/common/BaseService.js';
import Utils from '@/ecm/common/Utils.js';

class LockedDocumentService {
    baseUrl = 'locked-document';

    getGrid = () => Utils.grid.getParameters(`${this.baseUrl}/get-grid`);
    unlock = (ids) => BaseService.put({ url: `${this.baseUrl}/unlock`, data: ids });
    unlockOwned = (lockedDocumentId) => BaseService.put({ url: `${this.baseUrl}/unlock-owned/${lockedDocumentId}` });
}

export default new LockedDocumentService();
